/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareLabelValuePair,
  SterWebsiteModelPriceCompareLabelValuePairFromJSON,
  SterWebsiteModelPriceCompareLabelValuePairFromJSONTyped,
  SterWebsiteModelPriceCompareLabelValuePairToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareOperator
 */
export interface SterWebsiteModelPriceCompareOperator {
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareOperator
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareOperator
   */
  value: string;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareLabelValuePair>}
   * @memberof SterWebsiteModelPriceCompareOperator
   */
  channels: Array<SterWebsiteModelPriceCompareLabelValuePair>;
}

export function SterWebsiteModelPriceCompareOperatorFromJSON(
  json: any
): SterWebsiteModelPriceCompareOperator {
  return SterWebsiteModelPriceCompareOperatorFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareOperator {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
    channels: (json["channels"] as Array<any>).map(
      SterWebsiteModelPriceCompareLabelValuePairFromJSON
    ),
  };
}

export function SterWebsiteModelPriceCompareOperatorToJSON(
  value?: SterWebsiteModelPriceCompareOperator | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    label: value.label,
    value: value.value,
    channels: (value.channels as Array<any>).map(
      SterWebsiteModelPriceCompareLabelValuePairToJSON
    ),
  };
}
